import Image from "next/image";

const OnTheJobLearning = ({ data }) => {
  return (
    <section className="max-w-(--max-page-width) mx-auto px-(--container-padding) my-10 md:my-16 lg:my-24">

      <div className="w-full mx-auto">

        <div className="max-w-2xl mb-5 md:mb-10">
          <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
            {data.tag}
          </span>

          <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold mt-4">
            {data.title}
          </h2>
          <p className="text-[#000000] mt-3 text-lg">
            {data.description}
          </p>

        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">

          {data.images.map((item) => (
            <div key={item.id} className="w-full overflow-hidden">
              <Image
                src={item.src}
                alt={item.alt}
                width={500}
                height={200}
                className="w-full h-auto object-cover"
              />
            </div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default OnTheJobLearning;